import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import _ from "lodash";
import {
  TextField,
  MenuItem,
  Typography,
  Menu,
  IconButton,
  Stack,
  Tooltip,
  useTheme,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import makeStyles from "@mui/styles/makeStyles";
import { Marker } from "react-mark.js";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import moment from "moment";

export const FilterDropdown = ({
  handleOptionClick,
  handleClose,
  anchorEl,
  handleClick,
  selectedOption,
}) => {
  return (
    <div>
      <IconButton
        aria-controls="filter-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <FilterAltIcon />
      </IconButton>
      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          selected={selectedOption === "With Text"}
          onClick={() => handleOptionClick("With Text")}
        >
          With Text
        </MenuItem>
        <MenuItem onClick={() => handleOptionClick("Without Text")}>
          Without Text
        </MenuItem>
        <MenuItem onClick={() => handleOptionClick("With Response")}>
          With Response
        </MenuItem>
        <MenuItem onClick={() => handleOptionClick("Without Response")}>
          Without Response
        </MenuItem>
      </Menu>
    </div>
  );
};

export const isValidJSON = (jsonString) => {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
};

export const ReviewSearch = ({ onSearch, searchTerm, setSearchTerm }) => {
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    if (searchTerm === "") setSearchText("");
  }, [searchTerm]);
  const handleSearch = useCallback((value) => {
    onSearch(value);
  }, []);
  const throttledSearch = useMemo(() => {
    return _.throttle(handleSearch, 500);
  }, [handleSearch]);
  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    setSearchText(newSearchTerm);
    throttledSearch(newSearchTerm);
  };

  return (
    <div style={{ marginRight: "5px" }}>
      <TextField
        sx={{ width: "100%", maxWidth: 400, margin: "0 auto", zIndex: 999 }}
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        fullWidth
        size="small"
      />
    </div>
  );
};

export const useStyles = makeStyles(() => ({
  reviewContainer: {
    // width: "calc(100vw - 910px)",
    height: "calc(100vh - 230px)",
    overflowY: "auto",
  },
  reviewContainer2: {
    // paddingLeft: "16px",
    marginTop: "16px",
    height: "calc(100vh - 200px)",
    overflowY: "auto",
  },
  reviewBox: {
    padding: "16px",
    marginBottom: "16px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ccc",
  },
  reviewHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  rating: {
    marginBottom: "8px",
  },
  reviewText: {
    marginBottom: "16px",
  },
  footer: {
    position: "sticky",
    bottom: 0,
    background: "white",
    padding: "8px 16px",

    borderTop: "1px solid #ccc",
    display: "flex",
    justifyContent: "flex-end",
  },
  selected: {
    position: "sticky",
    bottom: 0,
    background: "white",
    padding: "16px",
    borderTop: "1px solid #ccc",
    display: "flex",
    justifyContent: "flex-start",
  },
  checkbox: {
    marginRight: "8px",
    marginBottom: "5px",
    display: "flex",
    justifyContent: "flex-end",
  },
  selectAllButton: {
    cursor: "pointer",
  },
}));

export const ReviewItem = ({
  review,
  noReviewText = false,
  searchTerm = false,
  selectedShowType,
  handleAddList
}) => {
  const theme = useTheme();
  const [showFullText, setShowFullText] = useState(false);

  const toggleFullText = () => {
    setShowFullText(!showFullText);
  };
  const handleListbutton = (e) => {
    handleAddList(review)
    e.stopPropagation()
  }
  const reviewText = React.useMemo(
    () => review?.reviewText || "No review text available",
    [review]
  );

  return (
    <div style={{ position: 'relative' }}>
      <Typography variant="body1">
        {!noReviewText && (
          <Typography
            mark={searchTerm ? searchTerm : ""}
            id={review?.reviewText ? "" : "text-muted"}
            sx={{fontSize:'15px'}}
          >
            {reviewText}  
            {/* {review?.author && (<>
                           
                           <Typography component={'span'} position={'relative'} ml={1} sx={{whiteSpace:'nowrap'}}>
                              <PersonOutlineIcon sx={{position:'absolute', fontSize:'21px'}}/>
                              <Typography component={'span'} fontStyle={'italic'} sx={{marginLeft:'25px', fontSize: '15px', color: '#5b6b79'}}>
                                 {review?.author || ""}
                              </Typography>
                           </Typography>
                          
                          <Typography
                            variant="body1"
                            sx={{ fontSize: "15px" }}
                            color="textSecondary"
                            component={"span"}
                            fontStyle={"italic"}
                            fontWeight={500}
                          >
                            
                            </Typography></>)} */}


            {/* { reviewText : reviewText?.slice(0, 150)}
          {reviewText.length > 150 && !showFullText && <span>...</span>}
          {reviewText?.length > 150 && (
            <span
              style={{ cursor: "pointer", marginLeft: 10, color: "#1976d2" }}
              onClick={() => toggleFullText()}
            >
              {showFullText ? "Less" : "More"}
            </span>
          )} */}
          </Typography>
        )}

        {review?.responseText && (
          <div
            style={{
              borderRadius: "10px",
              backgroundColor: "rgba(0, 0, 0, 0.125)",
              padding: "10px",
              marginTop: "8px"
             
            }}
          >
            <Typography variant="body2" style={{ fontSize: "14px" }}>
                <b>Response</b> &nbsp;&nbsp;{" "}
                <Tooltip title={moment(new Date(review?.responseDateTime).toLocaleDateString()).format("MM/DD/YYYY hh:mm:ss A [IST]")} arrow>
                   {new Date(review?.responseDateTime).toLocaleDateString()}
               </Tooltip>
            </Typography>
            <Typography
              
              mark={searchTerm ? searchTerm : ""}
              style={{ marginTop: "5px", fontSize:'14px !important' }}
              variant="body2"
            >
              {review.responseText}
            </Typography>
          </div>
        )}
      </Typography>
      {selectedShowType === 'database' && <Stack direction={'row'} justifyContent={'right'}>

      </Stack>}
    </div>
  );
};
